import { createContext as e, useCallback as t, useContext as n, useReducer as r } from "react";
import { keyframes as i, styled as a } from "styled-components";
import { useTranslation as o } from "@maat/store-i18n";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
import { AlertTriangle as l, CheckCircle2 as u, Info as d, XCircle as f } from "lucide-react";
import * as p from "@radix-ui/react-toast";
//#region src/components/Toast/Toast.tsx
var m = e({ toast: () => {} }), h = (e, t) => t.type === "ADD" ? [...e, t.item] : t.type === "REMOVE" ? e.filter((e) => e.id !== t.id) : e, g = i`
    from { transform: translateX(calc(100% + 24px)); opacity: 0; }
    to   { transform: translateX(0); opacity: 1; }
`, _ = i`
    from { opacity: 1; }
    to   { opacity: 0; }
`, v = (e, t) => ({
	default: t.colors.primary,
	success: t.colors.success,
	destructive: t.colors.destructive,
	warning: t.colors.warning
})[e], y = {
	default: d,
	success: u,
	destructive: f,
	warning: l
}, b = a(p.Viewport)`
    position: fixed;
    bottom: 24px;
    right: 24px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 400px;
    max-width: calc(100vw - 48px);
    z-index: 9999;
    list-style: none;
    padding: 0;
    margin: 0;
    outline: none;
`, x = a(p.Root)`
    position: relative;
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    padding: ${({ theme: e }) => e.spacing(2, 2.5)};
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.lg};
    background-color: ${({ theme: e }) => e.colors.card};
    box-shadow: ${({ theme: e }) => e.shadows.lg};
    overflow: hidden;

    &[data-state='open'] {
        animation: ${g} 250ms cubic-bezier(0.16, 1, 0.3, 1);
    }
    &[data-state='closed'] {
        animation: ${_} 100ms ease-in;
    }
`, S = a.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 50%;
    pointer-events: none;
    border-radius: inherit;
    background: ${({ theme: e, $variant: t }) => `linear-gradient(to right, ${v(t, e)}22, transparent)`};
`, C = a.div`
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 50%;
    background: ${({ theme: e, $variant: t }) => `${v(t, e)}20`};
    color: ${({ theme: e, $variant: t }) => v(t, e)};
`, w = a.div`
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
`, T = a(p.Title)`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.cardForeground};
    margin: 0;
    line-height: 1.3;
`, E = a(p.Description)`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    margin: 0;
    margin-top: 2px;
    line-height: 1.4;
`, D = a(p.Close)`
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: none;
    background-color: transparent;
    color: ${({ theme: e }) => e.colors.mutedForeground};
    border-radius: ${({ theme: e }) => e.radii.sm};
    cursor: pointer;
    align-self: start;
    transition: all ${({ theme: e }) => e.transitions.fast};
    &:hover {
        background-color: ${({ theme: e }) => e.colors.muted};
    }
`, O = a(p.Action)`
    position: relative;
    z-index: 1;
    align-self: center;
    border: 1px solid ${({ theme: e }) => e.colors.border};
    background: transparent;
    color: ${({ theme: e }) => e.colors.foreground};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.medium};
    padding: 4px 10px;
    border-radius: ${({ theme: e }) => e.radii.sm};
    cursor: pointer;
    white-space: nowrap;
    transition: all ${({ theme: e }) => e.transitions.fast};
    &:hover {
        background-color: ${({ theme: e }) => e.colors.muted};
    }
`, k = ({ children: e }) => {
	let { t: n } = o("common"), [i, a] = r(h, []), l = t((e) => {
		let t = Math.random().toString(36).slice(2);
		a({
			type: "ADD",
			item: {
				...e,
				id: t
			}
		});
	}, []);
	return /* @__PURE__ */ s(m.Provider, {
		value: { toast: l },
		children: /* @__PURE__ */ c(p.Provider, {
			swipeDirection: "right",
			children: [
				e,
				i.map((e) => {
					let t = e.variant ?? "default", r = y[t];
					return /* @__PURE__ */ c(x, {
						$variant: t,
						duration: e.duration ?? 4e3,
						onOpenChange: (t) => {
							t || a({
								type: "REMOVE",
								id: e.id
							});
						},
						children: [
							/* @__PURE__ */ s(S, { $variant: t }),
							/* @__PURE__ */ s(C, {
								$variant: t,
								children: /* @__PURE__ */ s(r, { size: 20 })
							}),
							/* @__PURE__ */ c(w, { children: [/* @__PURE__ */ s(T, { children: e.title }), e.description && /* @__PURE__ */ s(E, { children: e.description })] }),
							e.action && /* @__PURE__ */ s(O, {
								altText: e.action.label,
								onClick: e.action.onClick,
								children: e.action.label
							}),
							/* @__PURE__ */ s(D, {
								"aria-label": n("common:actions.close"),
								children: /* @__PURE__ */ s("svg", {
									width: "12",
									height: "12",
									viewBox: "0 0 12 12",
									fill: "none",
									children: /* @__PURE__ */ s("path", {
										d: "M9 3L3 9M3 3l6 6",
										stroke: "currentColor",
										strokeWidth: "1.5",
										strokeLinecap: "round"
									})
								})
							})
						]
					}, e.id);
				}),
				/* @__PURE__ */ s(b, {})
			]
		})
	});
}, A = () => n(m);
//#endregion
export { k as Toaster, A as useToast };
